import { jsx as _jsx } from "react/jsx-runtime";
import { Card, Text, User } from "@gravity-ui/uikit";
export var PlaceCardShort = function (props) {
    var _a;
    return (_jsx(Card, { className: "g-s__p_2", onClick: function () { return props.onDetailsClick(props.place.id); }, type: "action", view: "outlined", theme: "normal", children: _jsx(User, { avatar: ((_a = props.place.covers) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? { imgUrl: props.place.covers[0].fileUrl, shape: "square" }
                : { text: props.place.name, theme: "brand", shape: "square" }, name: _jsx(Text, { variant: "header-1", children: props.place.name }), description: props.place.city.name, size: "xl" }) }));
};
